import axios from "axios";

// Auth is now cookie-only + CSRF double-submit protected.
// - Backend sets an HttpOnly `access_token` cookie on login/MFA verify.
// - `withCredentials: true` makes the browser attach the cookie on every request.
// - No JavaScript can read the access_token cookie — this eliminates the XSS
//   token-theft risk flagged by the code review.
// - Backend also sets a JS-readable `XSRF-TOKEN` cookie on GET /api/auth/csrf.
//   Axios auto-copies its value into the `X-CSRF-Token` request header on every
//   state-changing (POST/PUT/PATCH/DELETE) request. The server's CSRF middleware
//   rejects the request when the header is missing or does not match the cookie,
//   which defeats cross-site request forgery.
// - Backend also still accepts `Authorization: Bearer <token>` (and skips CSRF
//   when it sees one) so pytest fixtures and CLI tools continue to work.
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-CSRF-Token",
});

// One-time migration: users who signed in BEFORE the cookie-only switch may still
// have a stale JWT in localStorage. It cannot be turned into an HttpOnly cookie
// from the client side (the server would have to see it first), so we simply
// remove it. Any live cookie continues to work. Users without a cookie will be
// asked to log in again — which is the correct behaviour.
try { localStorage.removeItem("access_token"); } catch { /* ignore */ }

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}

export default api;
